import { getAutoplayCapabilities } from '@cbsinteractive/avia-js';
import { LocalStorageName } from 'components/videoPreview/videoPreviewConstants';

let initAutoplay = true;
//As this is a one-time check, we can use a simple boolean flag to ensure it runs only once.
export async function checkAutoplayCapabilities() {
    if (!initAutoplay) return;

    // Reset the flag to prevent re-initialization
    initAutoplay = false;

    try {
        const supportsUnmuted = await supportsUnmutedAutoplay();
        if (!supportsUnmuted) {
            localStorage.setItem(LocalStorageName.VOLUME_ON, 0);
        }
    } catch (e) {
        console.error('Autoplay capability error', e);
    }
}

export async function supportsUnmutedAutoplay() {
    try {
        const autoplayCapabilities = await getAutoplayCapabilities();
        return autoplayCapabilities.supportsUnmutedAutoplay;
    } catch (e) {
        return false;
    }
}

export async function supportsMutedAutoplay() {
    try {
        const autoplayCapabilities = await getAutoplayCapabilities();
        return autoplayCapabilities.supportsMutedAutoplay;
    } catch (e) {
        return false;
    }
}
